import { useState } from 'react';
import { alertarClickWhatsApp } from '../../utils/emailAlerts';

const getWhatsAppContext = (): { message: string; service: string; tooltip: string } => {
  const currentPath = window.location.pathname;

  const contexts: Record<string, { message: string; service: string; tooltip: string }> = {
    '/servicos/automovel': {
      message: 'Olá! Vi sobre o Seguro Automóvel no site da IBX Brasil e gostaria de uma cotação gratuita. Quero economizar até 45% no meu seguro!',
      service: 'Seguro Automóvel',
      tooltip: 'Falar com consultores',
    },
    '/servicos/vida-empresarial': {
      message: 'Olá! Quero conhecer o Seguro de Vida Empresarial da IBX Brasil. Preciso de proteção para sócios e colaboradores-chave da minha empresa.',
      service: 'Vida Empresarial',
      tooltip: 'Falar com consultores',
    },
    '/servicos/gestao-contratos': {
      message: 'Olá! Quero conhecer o serviço de Gestão de Contratos da IBX Brasil. Tenho várias apólices e preciso organizar tudo para economizar.',
      service: 'Gestão de Contratos',
      tooltip: 'Falar com consultores',
    },
    '/servicos/recuperacao-sinistros': {
      message: 'Olá! Tenho um sinistro que foi negado/questionado pela seguradora e vi que a IBX Brasil faz Recuperação de Sinistros. Podem analisar meu caso gratuitamente?',
      service: 'Recuperação de Sinistros',
      tooltip: 'Falar com consultores',
    },
    '/servicos/consultoria-tecnica': {
      message: 'Olá! Vi sobre a Consultoria Técnica da IBX Brasil e gostaria de uma análise gratuita dos meus seguros. Quero saber se posso economizar.',
      service: 'Consultoria Técnica',
      tooltip: 'Falar com consultores',
    },
    '/seguros-mal-contratados': {
      message: 'Olá! Vi no site sobre seguros mal contratados e quero uma análise urgente dos meus contratos. Posso estar pagando mais do que deveria!',
      service: 'Análise de Seguros Mal Contratados',
      tooltip: 'Falar com consultores',
    },
    '/contato': {
      message: 'Olá! Estou na página de contato da IBX Brasil e gostaria de falar com a equipe sobre seguros. Quando podemos conversar?',
      service: 'Contato Geral',
      tooltip: 'Falar com consultores',
    },
  };

  return contexts[currentPath] || {
    message: 'Olá! Vi o site da IBX Brasil e gostaria de conhecer os serviços de consultoria em seguros. Quando podemos conversar?',
    service: 'Interesse Geral',
    tooltip: 'Falar com consultores',
  };
};

export default function WhatsAppButton() {
  const WHATSAPP_NUMBER = '5577988080505';
  const [hovered, setHovered] = useState(false);

  const handleWhatsAppClick = async () => {
    const context = getWhatsAppContext();
    await alertarClickWhatsApp(
      context.service,
      window.location.pathname,
      `Clique no WhatsApp para ${context.service}`
    );
    const whatsappURL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(context.message)}`;
    window.open(whatsappURL, '_blank', 'nofollow,noreferrer');
  };

  const context = getWhatsAppContext();
  const isUrgent = context.service.includes('Recuperação') || context.service.includes('Mal Contratados');

  return (
    <div
      className="whatsapp-floating-button fixed bottom-6 right-6 z-50"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
    >
      
      {/* Tooltip — renderizado à esquerda do botão, fora do botão */}
      {hovered && (
        <div
          className="mr-3 hidden sm:flex items-center"
          aria-hidden="true"
          style={{ pointerEvents: 'none' }}
        >
          <div
            className={`px-4 py-2 rounded-lg shadow-xl text-sm font-semibold text-white ${
              isUrgent ? 'bg-red-700' : 'bg-gray-900'
            }`}
            style={{ whiteSpace: 'nowrap' }}
          >
            {context.tooltip}
          </div>
          {/* Seta apontando para o botão */}
          <div
            className={`w-0 h-0 ${isUrgent ? 'border-l-red-700' : 'border-l-gray-900'}`}
            style={{
              borderTop: '6px solid transparent',
              borderBottom: '6px solid transparent',
              borderLeft: `6px solid ${isUrgent ? '#b91c1c' : '#111827'}`,
              flexShrink: 0,
            }}
          />
        </div>
      )}

      {/* Botão circular */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-3xl group"
        style={{ backgroundColor: '#1F7A4C', border: 'none', cursor: 'pointer' }}
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl text-white group-hover:rotate-12 transition-transform"></i>
      </button>
    </div>
  );
}
